module.exports = __webpack_public_path__ + "img/11_of_Hearts.svg.b2bc6cf7.png";